function validateNumberField(item) {
	if (isNaN(item)) {
		return false;
	} else {
		return true;
	}
}

function validateMinValue(item) {
	if (1 / Number(item) > 0 && item !== '0') {
		return true;
	} else {
		return false;
	}
}

function validateDecimalLengthField(item, length = 2) {
	if (item) {
		var decimal = item.toString().split('.')[1];
		if (decimal) {
			return decimal.length <= length;
		}
	}

	return true;
}

function excelDateToJSDate(excelDate) {
	return new Date(-2209075200000 + (excelDate - (excelDate < 61 ? 0 : 1)) * 86400000);
}

export { validateNumberField, validateMinValue, validateDecimalLengthField, excelDateToJSDate };
